import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { SelectableBox } from "@src/appV2/redesign/components/SelectableBox";

import {
  FOOTER_BUTTON_MIN_WIDTH,
  TB_TEST_TYPE_DESCRIPTIONS,
  TB_TEST_TYPE_LABELS,
  TB_TEST_TYPE_OPTIONS,
} from "../constants";
import { type TbTestType } from "../types";

interface TestTypeSelectionStepProps {
  selectedTestType: TbTestType | undefined;
  onTestTypeSelected: (testType: TbTestType) => void;
  onNext: () => void;
  onBack: () => void;
}

export function TestTypeSelectionStep(props: TestTypeSelectionStepProps) {
  const { selectedTestType, onTestTypeSelected, onNext, onBack } = props;

  return (
    <>
      <DialogContent>
        <Stack spacing={8}>
          <Text variant="h3">Which TB test have you completed recently?</Text>

          <Stack spacing={4}>
            {TB_TEST_TYPE_OPTIONS.map((testType) => {
              const label = TB_TEST_TYPE_LABELS[testType];
              const description = TB_TEST_TYPE_DESCRIPTIONS[testType];

              return (
                <SelectableBox
                  key={testType}
                  variant="secondary"
                  isSelected={selectedTestType === testType}
                  sx={(theme) => ({
                    backgroundColor: theme.palette.background.quaternary,
                    borderColor: theme.palette.border?.primary,
                    textAlign: "left",
                  })}
                  onToggleSelect={() => {
                    onTestTypeSelected(testType);
                  }}
                >
                  <Stack gap={2}>
                    <Text variant="body1">{label}</Text>
                    {isDefined(description) && (
                      <Text
                        variant="body2"
                        sx={(theme) => ({ color: theme.palette.text.secondary })}
                      >
                        {description}
                      </Text>
                    )}
                  </Stack>
                </SelectableBox>
              );
            })}
          </Stack>
        </Stack>
      </DialogContent>

      <DialogFooter withShadow orientation="horizontal">
        <Button
          size="large"
          variant="text"
          sx={{ minWidth: FOOTER_BUTTON_MIN_WIDTH }}
          onClick={onBack}
        >
          Back
        </Button>
        <Button
          size="large"
          disabled={!isDefined(selectedTestType)}
          variant="contained"
          sx={{ minWidth: FOOTER_BUTTON_MIN_WIDTH }}
          onClick={onNext}
        >
          Next
        </Button>
      </DialogFooter>
    </>
  );
}
